export const UI_CLICK_AUDIO_URL = '/audio/click.wav';
export const SOUND_PREFERENCE_STORAGE_KEY = 'glass-shot:sound';

export function playDomUiClick(): void {
  try {
    if (localStorage.getItem(SOUND_PREFERENCE_STORAGE_KEY) === 'off') return;
  } catch {
    // A click can still play when storage is unavailable.
  }
  const audio = new Audio(UI_CLICK_AUDIO_URL);
  audio.volume = 0.42;
  void audio.play().catch(() => {
    // The access gate remains usable when a browser blocks audio playback.
  });
}
